// Module
var code = "<a href=\"http://{MOLLIE}TableName;RecordId;EUR;Amount;Description{/MOLLIE}\" data-mollie-btn=\"true\" style=\"display:inline-block;padding:10px 20px;background-color:#007bff;color:#fff;text-decoration:none;border-radius:4px;font-family:Arial,sans-serif;font-size:14px\" target=\"_blank\" rel=\"noopener\">Pay Now</a>";
// Exports
export default code;